import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';

import {
  bibShape,
  shelfItemShape,
  userIdentityShape,
  ugcCommentShape,
  ugcQuotationShape,
  ugcRatingShape,
  ugcTagShape,
  ugcVideoShape,
  ugcIOwnThisShape,
  ugcSimilarTitlesShape,
  ugcPrivateNoteShape,
  ugcContentAdvisoryShape,
  ugcAgeSuitabilityShape,
  ugcSummaryShape
} from '@bibliocommons/bc-prop-types';

import BibListItem from '../../../shared/BibListItem';
import ShelfListItemBibBriefInfoContainer from '../BibBriefInfo/BibBriefInfoContainer';
import ShelfListItemFooterInfo from '../FooterInfo';
import ShelfListItemSecondaryInfo from '../SecondaryInfo';

export class ShelfListItem extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderBibBrief() {
    return (
      <ShelfListItemBibBriefInfoContainer
        bib={this.props.bib}
        item={this.props.item}
        owner={this.props.owner}
        currentLibrary={this.props.currentLibrary}
        availabilityDetailActions={this.props.availabilityDetailActions}
        shelfName={this.props.shelfName}
        ownerRatingForBib={this.props.ownerRatingForBib}
        handleAvailabilityLinkClick={this.props.handleAvailabilityLinkClick}
      />
    );
  }

  renderSecondaryInfo() {
    return (
      <ShelfListItemSecondaryInfo
        item={this.props.item}
        owner={this.props.owner}
        shelfActions={this.props.shelfActions}
        ownerSettingForBib={this.props.ownerSettingForBib}
        shelfTransactions={this.props.shelfTransactions}
        iOwnThisActions={this.props.iOwnThisActions}
        iOwnThisTransactions={this.props.iOwnThisTransactions}
        currentUserShelfItemForBib={this.props.currentUserShelfItemForBib}
        modalActions={this.props.modalActions}
        trackContentCollectionMove={this.props.trackContentCollectionMove}
      />
    );
  }

  renderFooterInfo() {
    return (
      <ShelfListItemFooterInfo
        bib={this.props.bib}
        item={this.props.item}
        owner={this.props.owner}
        ownerCommentForBib={this.props.ownerCommentForBib}
        ownerQuotationsForBib={this.props.ownerQuotationsForBib}
        ownerTagsForBib={this.props.ownerTagsForBib}
        ownerVideoForBib={this.props.ownerVideoForBib}
        ownerSimilarTitlesForBib={this.props.ownerSimilarTitlesForBib}
        ownerPrivateNoteForBib={this.props.ownerPrivateNoteForBib}
        ownerContentAdvisoriesForBib={this.props.ownerContentAdvisoriesForBib}
        ownerAgeSuitabilityForBib={this.props.ownerAgeSuitabilityForBib}
        ownerSummaryForBib={this.props.ownerSummaryForBib}
        similarTitleBibs={this.props.similarTitleBibs}
        commentsTransactions={this.props.commentsTransactions}
        quotationsTransactions={this.props.quotationsTransactions}
        shelfTransactions={this.props.shelfTransactions}
        tagsTransactions={this.props.tagsTransactions}
        videosTransactions={this.props.videosTransactions}
        similarTitlesTransactions={this.props.similarTitlesTransactions}
        privateNotesTransactions={this.props.privateNotesTransactions}
        contentAdvisoriesTransactions={this.props.contentAdvisoriesTransactions}
        ageSuitabilitiesTransactions={this.props.ageSuitabilitiesTransactions}
        summariesTransactions={this.props.summariesTransactions}
        commentsActions={this.props.commentsActions}
        quotationsActions={this.props.quotationsActions}
        tagsActions={this.props.tagsActions}
        videosActions={this.props.videosActions}
        similarTitlesActions={this.props.similarTitlesActions}
        shelfActions={this.props.shelfActions}
        privateNotesActions={this.props.privateNotesActions}
        contentAdvisoriesActions={this.props.contentAdvisoriesActions}
        ageSuitabilitiesActions={this.props.ageSuitabilitiesActions}
        summariesActions={this.props.summariesActions}
      />
    );
  }

  render() {
    const { bib } = this.props;

    return (
      <BibListItem
        bib={bib.get('briefInfo')}
        className="cp-shelf-list-item"
        renderBibBrief={() => this.renderBibBrief()}
        renderInfo={() => this.renderSecondaryInfo()}
        renderFooterInfo={() => this.renderFooterInfo()}
      />
    );
  }
}

ShelfListItem.propTypes = {
  currentLibrary: ImmutablePropTypes.map.isRequired,
  owner: userIdentityShape.isRequired,
  item: shelfItemShape.isRequired,
  bib: bibShape,
  shelfName: PropTypes.string.isRequired,
  currentUserShelfItemForBib: shelfItemShape,
  ownerCommentForBib: ugcCommentShape,
  ownerQuotationsForBib: ImmutablePropTypes.listOf(ugcQuotationShape),
  ownerRatingForBib: ugcRatingShape,
  ownerTagsForBib: ImmutablePropTypes.listOf(ugcTagShape),
  ownerVideoForBib: ugcVideoShape,
  ownerSimilarTitlesForBib: ImmutablePropTypes.listOf(ugcSimilarTitlesShape),
  ownerPrivateNoteForBib: ugcPrivateNoteShape,
  ownerContentAdvisoriesForBib: ImmutablePropTypes.listOf(ugcContentAdvisoryShape),
  ownerAgeSuitabilityForBib: ugcAgeSuitabilityShape,
  ownerSummaryForBib: ugcSummaryShape,
  ownerSettingForBib: ugcIOwnThisShape,
  similarTitleBibs: ImmutablePropTypes.map.isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  iOwnThisTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  contentAdvisoriesTransactions: ImmutablePropTypes.map.isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iOwnThisActions: PropTypes.objectOf(PropTypes.func).isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  contentAdvisoriesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func),
  handleAvailabilityLinkClick: PropTypes.func,
  trackContentCollectionMove: PropTypes.func
};

ShelfListItem.defaultProps = {
  bib: Immutable.Map()
};

export default ShelfListItem;
